var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedHatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 837,
    height: 65,
    viewBox: "0 0 837 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.754 0H396.084V12.9526H410.754V0Z",
    fill: "#FB1A50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.103 0H469.433V12.9526H484.103V0Z",
    fill: "#FB1A50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M704.15 0H689.48H674.81H660.14V12.9526H674.81H689.48H704.15H718.82V0H704.15Z",
    fill: "#FB1A50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M762.829 0H748.159V12.9526H762.829V0Z",
    fill: "#FB1A50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.029 12.9526H117.359V25.9053H132.029V12.9526Z",
    fill: "#FB1A50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205.377 12.9526H190.707V25.9053H205.377V12.9526Z",
    fill: "#FB1A50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M249.387 25.9053V38.8579H264.056V25.9053H278.726H293.396H308.066V12.9526H322.735V0H308.066H293.396H278.726V12.9526H264.056V0H249.387V12.9526H234.717V0H220.047H205.377V12.9526H220.047V25.9053H205.377V38.8579H220.047H234.717V25.9053H249.387Z",
    fill: "#FB1A50"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M469.433 12.9526H454.763V25.9053H469.433V12.9526Z",
    fill: "#FB1A50"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M498.773 12.9526H484.103V25.9053H498.773V12.9526Z",
    fill: "#FB1A50"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M718.82 25.9053H704.15H689.48V38.8579H704.15H718.82H733.489V25.9053V12.9526H718.82V25.9053Z",
    fill: "#FB1A50"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M821.508 12.9526V25.9053V38.8579H836.178V25.9053V12.9526H821.508Z",
    fill: "#FB1A50"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M176.038 38.8579H161.368V25.9053H176.038V12.9526H161.368V0H146.698H132.028V12.9526H146.698V25.9053H132.028V38.8579V51.8105V64.7627H146.698V51.8105H161.368V64.7627H176.038H190.707H205.377V51.8105H190.707V38.8579V25.9053H176.038V38.8579Z",
    fill: "#FB1A50"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M366.745 25.9058H352.075H337.405H322.735H308.066V38.8584H322.735H337.405H352.075H366.745V25.9058Z",
    fill: "#FB1A50"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M557.452 38.8579V25.9053H542.782V12.9526H528.112V0H513.443V12.9526V25.9053H528.112V38.8579H513.443H498.773H484.103V25.9053H469.433V38.8579H454.763V25.9053H440.094V12.9526H425.424H410.754V25.9053H396.084V38.8579H410.754V51.8105V64.7627H425.424H440.094H454.763V51.8105H469.433V64.7627H484.103H498.773H513.443V51.8105H528.112H542.782V38.8579H557.452Z",
    fill: "#FB1A50"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M660.14 25.9053H645.471V38.8579H630.801V25.9053H645.471V12.9526V0H630.801H616.131H601.461H586.791H572.122H557.452H542.782V12.9526H557.452V25.9053H572.122V12.9526H586.791H601.461V25.9053H586.791H572.122V38.8579H557.452V51.8105H572.122V64.7627H586.791V51.8105H601.461H616.131V64.7627H630.801V51.8105H645.471H660.14V38.8579V25.9053Z",
    fill: "#FB1A50"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0185 38.8579V25.9053H102.689V12.9526H88.0185V0H73.349V12.9526H58.679V25.9053H73.349V38.8579H58.679V25.9053H44.0095V12.9526H58.679V0H44.0095H29.3395H14.67H0V12.9526H14.67V25.9053H29.3395V38.8579H14.67V25.9053H0V38.8579V51.8105H14.67H29.3395V64.7627H44.0095V51.8105H58.679H73.349H88.0185H102.689V38.8579H88.0185Z",
    fill: "#FB1A50"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M249.387 38.8584H234.717V51.811V64.7632H249.387H264.056V51.811H249.387V38.8584Z",
    fill: "#FB1A50"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M278.726 38.8584H264.056V51.811H278.726V64.7632H293.396V51.811H308.066V38.8584H293.396H278.726Z",
    fill: "#FB1A50"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M396.085 38.8584H381.415V51.811H396.085V38.8584Z",
    fill: "#FB1A50"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M792.168 38.8579V25.9053V12.9526H806.838H821.508V0H806.838H792.168H777.499V12.9526V25.9053H762.829H748.159V38.8579H762.829H777.499V51.8105H762.829V64.7627H777.499H792.168H806.838V51.8105H792.168V38.8579Z",
    fill: "#FB1A50"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M821.508 38.8584H806.838V51.811H821.508V38.8584Z",
    fill: "#FB1A50"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M117.359 51.8101H102.689V64.7627H117.359V51.8101Z",
    fill: "#FB1A50"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M322.736 51.8101H308.066V64.7627H322.736V51.8101Z",
    fill: "#FB1A50"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M352.075 51.8101H337.405V64.7627H352.075V51.8101Z",
    fill: "#FB1A50"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M381.415 51.8101H366.745V64.7627H381.415V51.8101Z",
    fill: "#FB1A50"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M557.452 51.8101H542.782V64.7627H557.452V51.8101Z",
    fill: "#FB1A50"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M674.81 51.8101H660.14V64.7622H674.81H689.48H704.15V51.8101H689.48H674.81Z",
    fill: "#FB1A50"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M733.489 51.8101H718.82V64.7627H733.489V51.8101Z",
    fill: "#FB1A50"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M836.178 51.8101H821.508V64.7627H836.178V51.8101Z",
    fill: "#FB1A50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHatch);
export default __webpack_public_path__ + "static/media/redHatch.af05899508f441283d233859455ed21d.svg";
export { ForwardRef as ReactComponent };